import axios from 'axios';

import {
  CommunityApiFactory,
  Configuration,
  FacilitatorApiFactory,
} from '@elevate/konnect-api-types';

const baseURL = import.meta.env.VITE_KONNECT_API_URL;

const axiosInstance = axios.create({
  baseURL,
});

const configuration = new Configuration({
  basePath: baseURL,
});

const community = CommunityApiFactory(configuration, baseURL, axiosInstance);
const facilitator = FacilitatorApiFactory(
  configuration,
  baseURL,
  axiosInstance,
);

export const apiClient = {
  community,
  facilitator,
  axiosInstance,
} as const;
